<template>
  <button
    :type="type"
    data-testid="submit_button"
    :disabled="disabled"
    :class="computedClass"
    :aria-busy="loading ? 'true' : 'false'"
    @click="onClick"
  >
    <fluent-icon v-if="!!iconClass" :icon="iconClass" class="icon" />
    <span>{{ buttonText }}</span>
    <spinner v-if="loading" class="ms-2" :color-scheme="spinnerClass" />
  </button>
</template>

<script>
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    Spinner,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonClass: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
    spinnerClass: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'submit',
    },
  },
  computed: {
    computedClass() {
      return `button nice gap-2 ${this.buttonClass || ' '}`;
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>
<style lang="scss" scoped>
// The disabled fill is deliberately a flat tint rather than a faded copy of the
// enabled button — `opacity-100` cancels Foundation's blanket 0.4. The `/25`
// modifier resolves against the `--woot-500` channel, so it keeps flipping per mode.
button:disabled {
  @apply bg-woot-100 dark:bg-woot-500/25 dark:text-slate-500 opacity-100 cursor-not-allowed;
  &:hover {
    @apply bg-woot-100 dark:bg-woot-500/25;
  }
}

// Same state matrix as `ui/WootButton.vue`.
button {
  @apply transition-[background-color,border-color,color,box-shadow,transform] duration-150 ease-out;

  &:focus-visible {
    @apply outline-none ring-2 ring-accent-mint/70 ring-offset-2 ring-offset-white dark:ring-offset-ink;
  }

  &:focus:not(:focus-visible) {
    @apply outline-none;
  }

  &:active:not(:disabled) {
    @apply scale-[0.97];
  }

  @media (prefers-reduced-motion: reduce) {
    @apply transition-none;

    &:active:not(:disabled) {
      @apply scale-100;
    }
  }
}
</style>
